import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AdminNavBarMain from './AdminNavBarMain'
import Cookies from 'js-cookie';
import Table from "react-bootstrap/Table";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { LOADER, LOADING, HIDING } from "../Constant";
import { GlobalLoader } from "../helpers";
import { toast } from "react-toastify";
import Select from 'react-select';


function EyeIcon() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path
                d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="12"
                cy="12"
                r="3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
            />
        </svg>
    )
}

const EKYCList = () => {

    const fileInputRef = useRef(null);
    const searchRef = useRef(null);

    const [items, setItems] = useState([])
    const [error, setError] = useState('')
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [uploadHistory, setUploadHistory] = useState([])


    const [defaultvalueInvestor, setDefaultValueForInvestor] = useState(false);
    const [clickedTabMain, setClickedTabMain] = useState('');
    const [enableSweetAlert, setEnableSweetAlert] = useState(null);
    const [lookups, setLookups] = useState(null)
    const [lookupFile, setLookupFile] = useState(null)
    const [uploadingLookups, setUploadingLookups] = useState(false)
    const [lookupUploadMsg, setLookupUploadMsg] = useState('')
    const [lookupMeta, setLookupMeta] = useState(null)
    const [search, setSearch] = useState(''
        // localStorage.getItem('ekyc_search') || ''
    );
    const [selectedRiskLevel, setSelectedRiskLevel] = useState(
        sessionStorage.getItem('riskLevel') || ''
    );

    const [selectedComplianceStatus, setSelectedComplianceStatus] = useState(
        sessionStorage.getItem('complianceStatus') || ''
    );
    const getLoadingAlert = (type) => {
        if (type === LOADING) {
            setEnableSweetAlert(true);
        } else {
            setEnableSweetAlert(false);
        }
    };




    // useEffect(() => {
    //     const savedSearch = sessionStorage.getItem('caseSearch');

    //     if (savedSearch && searchRef.current) {
    //         searchRef.current.value = savedSearch;
    //         loadCases(savedSearch);
    //     }

    //     const handleBeforeUnload = () => {
    //         sessionStorage.removeItem('caseSearch');
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    useEffect(() => {

        const savedSearch =
            sessionStorage.getItem('caseSearch');

        const savedRiskLevel =
            sessionStorage.getItem('riskLevel');

        const savedComplianceStatus =
            sessionStorage.getItem('complianceStatus');

        if (
            savedSearch &&
            searchRef.current
        ) {
            searchRef.current.value = savedSearch;
        }

        loadCases(
            savedSearch || '',
            savedRiskLevel || '',
            savedComplianceStatus || ''
        );

        const handleBeforeUnload = () => {

            sessionStorage.removeItem('caseSearch');
            sessionStorage.removeItem('riskLevel');
            sessionStorage.removeItem('complianceStatus');

        };

        window.addEventListener(
            'beforeunload',
            handleBeforeUnload
        );

        return () => {

            window.removeEventListener(
                'beforeunload',
                handleBeforeUnload
            );

        };

    }, []);



    useEffect(() => {
        if (!Cookies.get("User_Accesstoken_Admin")) {
            navigate("/adminlogin");
            return;
        }

        const onboardingTab = document.getElementById("onboarding-tab");
        const onboardingPane = document.getElementById("onboarding-tab-pane");
        const businessTab = document.getElementById("business-tab");
        const businessPane = document.getElementById("business-tab-pane");
        const newInvestmentTab = document.getElementById("newinvestment-tab");
        const newInvestmentPane = document.getElementById("newinvestment-tab-pane");

        if (Cookies.get("is_first_tab") === "false") {
            onboardingTab?.classList.remove("active");
            onboardingPane?.classList.remove("active");

            if (Cookies.get("clicked_tab") === "newinvestment") {
                newInvestmentTab?.classList.add("active");
                newInvestmentPane?.classList.add("active");
            } else if (Cookies.get("clicked_tab") === "business") {
                businessTab?.classList.add("active");
                businessPane?.classList.add("active");
            }

            setDefaultValueForInvestor(true);
        } else {
            setDefaultValueForInvestor(false);

            businessTab?.classList.remove("active");
            businessPane?.classList.remove("active");

            newInvestmentTab?.classList.remove("active");
            newInvestmentPane?.classList.remove("active");

            onboardingTab?.classList.add("active");
            onboardingPane?.classList.add("active");
        }
    }, []);

    const onBoardClick = (board) => {
        setClickedTabMain(board)
        Cookies.set("clicked_tab", board, { expires: 7 });
        Cookies.set("is_first_tab", true, { expires: 7 });
        setDefaultValueForInvestor(false);
    };
    const businessClick = (business) => {
        setClickedTabMain(business)
        Cookies.set("clicked_tab", business, { expires: 7 });
        Cookies.set("is_first_tab", false, { expires: 7 });
        setDefaultValueForInvestor(true);
    };






    useEffect(() => {




        loadCases(search, selectedRiskLevel, selectedComplianceStatus);
        loadUploadHistory();
    }, [search]);

    // const loadCases = async (
    //     searchText = '',
    //     riskLevelValue = '',
    //     complianceStatusValue = ''
    // ) => {
    //     try {
    //         const base = process.env.REACT_APP_API_BASE_URL;
    //         getLoadingAlert(LOADING);


    //         const query = new URLSearchParams();

    //         if (searchText) {
    //             query.append('q', searchText);
    //         }

    //         if (riskLevelValue) {
    //             query.append('risk_level', riskLevelValue);
    //         }

    //         if (complianceStatusValue) {
    //             query.append(
    //                 'compliance_status',
    //                 complianceStatusValue
    //             );
    //         }

    //         const res = await fetch(
    //             `${base}/ekyc/cases?${query.toString()}`,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json"
    //                 },
    //             }
    //         );
    //         getLoadingAlert(HIDING);

    //         const data = await res.json();
    //         setItems(data.items || []);

    //     } catch (err) {
    //         getLoadingAlert(HIDING);

    //         console.error(err);
    //     }
    // };


    const loadCases = async (
        searchText = '',
        riskLevelValue = '',
        complianceStatusValue = '',
        showLoader = true
    ) => {

        try {

            const base =
                process.env.REACT_APP_API_BASE_URL;

            if (showLoader) {
                getLoadingAlert(LOADING);
            }

            const query = new URLSearchParams();

            if (searchText) {
                query.append('q', searchText);
            }

            if (riskLevelValue) {
                query.append(
                    'risk_level',
                    riskLevelValue
                );
            }

            if (complianceStatusValue) {
                query.append(
                    'compliance_status',
                    complianceStatusValue
                );
            }

            const res = await fetch(
                `${base}/ekyc/cases?${query.toString()}`,
                {
                    headers: {
                        "Content-Type":
                            "application/json"
                    },
                }
            );

            if (showLoader) {
                getLoadingAlert(HIDING);
            }

            const data = await res.json();

            setItems(data.items || []);

        } catch (err) {

            if (showLoader) {
                getLoadingAlert(HIDING);
            }

            console.error(err);
        }
    };


    const loadUploadHistory = async () => {
        try {
            const base = process.env.REACT_APP_API_BASE_URL;
            getLoadingAlert(LOADING);

            const res = await fetch(`${base}/risk/lookups/history`, {
                headers: {
                    "Content-Type": "application/json"
                },
            });
            getLoadingAlert(HIDING);

            const data = await res.json();
            setUploadHistory(data.items || []);

        } catch (err) {
            getLoadingAlert(HIDING);

            console.error(err);
        }
    };




    useEffect(() => {

        const loadAll = async () => {

            try {

                // getLoadingAlert(LOADING);

                const [
                    lookupsData,
                    metaData,
                ] = await Promise.all([
                    fetchRiskLookups(),
                    fetchRiskLookupsMeta(),
                ]);

                setLookups(lookupsData);
                setLookupMeta(metaData);




            } catch (error) {

                console.error(error);

            } finally {


            }
        };



        loadAll();


    }, []);

    const uploadRiskLookupsCsv = async (file) => {
        const form = new FormData()
        form.append('file', file)
        const base = process.env.REACT_APP_API_BASE_URL;

        const res = await fetch(`${base}/risk/lookups/upload`, {
            method: 'POST',
            body: form,
        })
        if (!res.ok) {
            let msg = 'Failed to upload FATF CSV file. Please try again.                                    '
            try {
                const data = await res.json()
                if (data?.detail) msg = data.detail
            } catch { }
            throw new Error(msg)
        }
        return await res.json()
    }

    const fetchRiskLookups = async () => {
        const base = process.env.REACT_APP_API_BASE_URL;

        const res = await fetch(`${base}/risk/lookups`, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (!res.ok) throw new Error("Lookups fetch failed");

        return await res.json();
    };

    const fetchRiskLookupsMeta = async () => {
        const base = process.env.REACT_APP_API_BASE_URL;
        const res = await fetch(`${base}/risk/lookups/meta`, {
            headers: { 'Content-Type': 'application/json' },
        })
        if (!res.ok) throw new Error('Failed to fetch risk lookup metadata')
        return res.json()
    }



    const onUploadLookups = async () => {
        if (!lookupFile) return
        setUploadingLookups(true)
        setLookupUploadMsg('')
        setError('')
        getLoadingAlert(LOADING);

        try {
            const res = await uploadRiskLookupsCsv(lookupFile)
            const latest = await fetchRiskLookups()
            setLookups(latest)
            if (res?.meta) setLookupMeta(res.meta)
            toast.success("CSV file uploaded successfully");
            setLookupFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            await loadUploadHistory();

            const nationalityCount = Math.max(0, Object.keys(latest?.nationality || {}).length - 1)
            const residenceCount = Math.max(0, Object.keys(latest?.residence || {}).length - 1)
            setLookupUploadMsg(`CSV uploaded (${res.format || 'csv'}). Nationality: ${nationalityCount}, Residence: ${residenceCount}`)

        } catch (e) {
            getLoadingAlert(HIDING);
            toast.error(e?.message || 'Failed to upload lookup CSV');
            setError(e?.message || 'Failed to upload lookup CSV')
            setLookupFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } finally {

            getLoadingAlert(HIDING);

            setUploadingLookups(false)
        }
    }


    const truncateFileName = (name, maxLength = 40) => {
        if (!name) return "";
        return name.length > maxLength
            ? name.substring(0, maxLength) + "..."
            : name;
    };

    const goToAdminDashboard = () => {
        navigate("/admindashboard");
    };



    const handleSearchChange = (e) => {

        const value = e.target.value;

        // Only when input fully cleared
        if (value.trim() === '') {

            sessionStorage.removeItem('caseSearch');

            // reset without loader
            loadCases(
                '',
                selectedRiskLevel,
                selectedComplianceStatus,
                false
            );
        }
    };

    const handleSearch = () => {
        const value = searchRef.current.value;

        if (value.trim().length >= 3) {
            sessionStorage.setItem('caseSearch', value);
            loadCases(value, selectedRiskLevel, selectedComplianceStatus);
        } else {
            toast.error('Minimum 3 characters are required');
        }
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const resetFields = () => {

        // clear states
        setSelectedRiskLevel('');
        setSelectedComplianceStatus('');

        // clear search input
        if (searchRef.current) {
            searchRef.current.value = '';
        }

        // clear session storage
        sessionStorage.removeItem('caseSearch');
        sessionStorage.removeItem('riskLevel');
        sessionStorage.removeItem('complianceStatus');

        loadCases();

    };




    return (
        <div>
            <AdminNavBarMain />

            <div className="row admin_body_main position-static bg-transparent ">
                <div className="d-flex justify-content-between">
                    <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
                        <h5 className="admin_serv"
                            onClick={() => goToAdminDashboard(true)}
                        >
                            <img

                                src="/images/left_arrow.svg"
                                alt="leftt"
                                className="indiv_loan_dtls"
                            />
                            &nbsp; eKYC
                        </h5>
                    </div>

                </div>
            </div>
            <GlobalLoader show={enableSweetAlert} />


            <div className="">

                <div className="compliance_top_tab pe-5 ps-5">
                    <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                        <li className="nav-item-inv" role="presentation">
                            <button
                                onClick={(e) => onBoardClick("onboard")}
                                className="nav-link-inv  p-1"
                                id="onboarding-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#onboarding-tab-pane"
                                type="button"
                                role="tab"
                                aria-controls="onboarding-tab-pane"
                                aria-selected="true"
                            >
                                <h3>EKYC Cases  </h3>
                            </button>
                        </li>
                        <li className="nav-item-inv" role="presentation">
                            <button
                                onClick={(e) => businessClick("business")}
                                className="nav-link-inv  p-1"
                                id="business-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#business-tab-pane"
                                type="button"
                                role="tab"
                                aria-controls="business-tab-pane"
                                aria-selected="false"
                            >
                                <h3>FATF Upload</h3>
                            </button>
                        </li>


                    </ul>
                </div>


                <div
                    className="tab-content idiv_inv_left_card_text pe-5 ps-5"
                    id="myTabContent"
                >

                    <div
                        className="tab-pane fade show "
                        id="onboarding-tab-pane"
                        role="tabpanel"
                        aria-labelledby="onboarding-tab"
                        tabIndex="0"
                    >

                        <div>



                            <div className="case-header">

                                {/* Left Section */}
                                <div className="d-flex align-items-end gap-3">

                                    {/* Search */}
                                    <div className="case-left position-relative">
                                        <input
                                            ref={searchRef}
                                            id="all"
                                            name="all"
                                            type="text"
                                            className="form-control rounded py-3 border-0"
                                            placeholder="Search by Investor Name/ID"
                                            onChange={handleSearchChange}
                                            onKeyDown={handleSearchKeyDown}
                                            style={{
                                                width: '340px',
                                                paddingLeft: '15px',
                                                paddingRight: '45px'
                                            }}
                                        />

                                        <button
                                            type="button"
                                            onClick={handleSearch}
                                            className="position-absolute border-0 bg-transparent"
                                            style={{
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#6c757d',
                                                zIndex: 1,
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>

                                    {/* Risk Status */}
                                    <div style={{ width: '220px' }}>
                                        <label className="form-label mb-1">
                                            <p>{'Risk Level'}</p>
                                        </label>

                                        <Select
                                            options={[
                                                { value: 'Pending', label: 'Pending' },
                                                { value: 'High', label: 'High' },
                                                { value: 'Medium', label: 'Medium' },
                                                { value: 'Low', label: 'Low' }
                                            ]}
                                            classNamePrefix="custom-select"
                                            value={
                                                selectedRiskLevel
                                                    ? {
                                                        value: selectedRiskLevel,
                                                        label: selectedRiskLevel
                                                    }
                                                    : null
                                            }
                                            onChange={(selected) => {

                                                const value = selected?.value || '';

                                                setSelectedRiskLevel(value);

                                                sessionStorage.setItem(
                                                    'riskLevel',
                                                    value
                                                );

                                                loadCases(
                                                    searchRef.current?.value || '',
                                                    value,
                                                    selectedComplianceStatus
                                                );
                                            }}
                                        />
                                    </div>

                                    {/* KYC Status */}
                                    <div style={{ width: '220px' }}>
                                        <label className="form-label mb-1">
                                            <p>{'KYC Status'}</p>
                                        </label>

                                        <Select
                                            options={[
                                                { value: 'Approved', label: 'Approved' },
                                                { value: 'Pending', label: 'Pending' },
                                                { value: 'Rejected', label: 'Rejected' }
                                            ]}
                                            classNamePrefix="custom-select"
                                            value={
                                                selectedComplianceStatus
                                                    ? {
                                                        value: selectedComplianceStatus,
                                                        label: selectedComplianceStatus
                                                    }
                                                    : null
                                            }
                                            onChange={(selected) => {

                                                const value = selected?.value || '';

                                                setSelectedComplianceStatus(value);

                                                sessionStorage.setItem(
                                                    'complianceStatus',
                                                    value
                                                );

                                                loadCases(
                                                    searchRef.current?.value || '',
                                                    selectedRiskLevel,
                                                    value
                                                );
                                            }}
                                        />
                                    </div>



                                    <div className=" col align-self-end">
                                        <button className="blue_btn" onClick={resetFields}>
                                            Clear All Filters
                                        </button>
                                    </div>

                                </div>

                                <div className="case-right">


                                    <span className="case-label-list">
                                        {items.length} Total
                                    </span>
                                </div>

                            </div>

                            <div className=" all_inv_newinv_table">
                                <Table
                                    striped
                                    // bordered
                                    className="bg-white ps-4 pe-4 text-center "
                                >
                                    <thead className=" Cpointer ">
                                        <tr>
                                            <th className={`text-black  ${"text-start"}`}>Investor Name</th>
                                            <th className={`text-black  ${"text-start"}`}>Investor ID</th>
                                            <th className={`text-black  ${"text-start"}`}>Created At</th>
                                            <th className={`text-black  ${"text-start"}`}> Risk Level</th>
                                            <th className={`text-black  ${"text-start"}`}>KYC Status</th>
                                            <th className={`text-black  ${"text-start"}`}>Action</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length > 0 ?
                                            (items.map((it) => (
                                                <tr key={it.caseId}>
                                                    <td>{it.investorName || '-'}</td>
                                                    <td>{it.investorId || '-'}</td>
                                                    <td>{it.createdAt ? moment(it.createdAt).format("DD-MMM-YYYY hh:mm A") : "-"}</td>





                                                    <td>
                                                        {it.riskLevel ? (
                                                            <span
                                                                className={
                                                                    it.riskLevel.toLowerCase() === 'high'
                                                                        ? 'tag-risk-high'
                                                                        : it.riskLevel.toLowerCase() === 'medium'
                                                                            ? 'tag-risk-medium'
                                                                            : it.riskLevel.toLowerCase() === 'low'
                                                                                ? 'tag-risk-low'
                                                                                : it.riskLevel.toLowerCase() === 'pending'
                                                                                    ? 'tag-risk-pending'
                                                                                    : 'risk-text'
                                                                }
                                                            >
                                                                {it.riskLevel}
                                                            </span>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </td>

                                                    <td>
                                                        <div
                                                            className={`kyc-status-badge ${(it.complianceStatusLabel || "").toLowerCase()
                                                                }`}
                                                        >
                                                            {it.complianceStatusLabel || "-"}
                                                        </div>
                                                    </td>


                                                    <td>


                                                        <Link
                                                            className={`evidence-btn ${it.isRejected ? "disabled-open-btn" : ""}`}
                                                            to={
                                                                !it.isRejected
                                                                    ? `/ekyc/details/${it.caseId}/${it.investorKycId}`
                                                                    : "#"
                                                            }
                                                            onClick={(e) => {
                                                                if (it.isRejected) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        >
                                                            Open
                                                        </Link>
                                                    </td>



                                                </tr>
                                            ))
                                            ) :
                                            (
                                                <tr>
                                                    <td
                                                        colSpan="7"
                                                        className="text-center py-4"
                                                    >
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            )
                                        }


                                    </tbody>





                                </Table>
                            </div>

                        </div>
                    </div>


                    {/* Business KYC Submissions Tab */}
                    <div
                        className="tab-pane fade show "
                        id="business-tab-pane"
                        role="tabpanel"
                        aria-labelledby="business-tab"
                        tabIndex="1"
                    >
                        <div className="mt-3">
                            <div className="card shadow-sm border-0 rounded-4 p-4 bg-white">
                                {/* Header */}
                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div>
                                        <h4 className="mb-1 fw-semibold text-dark">
                                            FATF CSV Upload
                                        </h4>
                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                            Upload the FATF CSV file to update risk scores.
                                        </p>
                                    </div>
                                </div>

                                {/* Upload Section */}
                                <div className="border rounded-3 p-4 bg-light">
                                    <div className="fatf-upload-row">
                                        {/* Hidden File Input */}
                                        <input
                                            type="file"
                                            accept=".csv,text/csv"
                                            id="fileUpload"
                                            hidden
                                            onChange={(e) => setLookupFile(e.target.files?.[0] || null)}
                                            ref={fileInputRef}
                                        />


                                        <button
                                            type="button"
                                            className="upload-btn-risk px-4 py-2"
                                            disabled={!lookupFile || uploadingLookups}
                                            onClick={onUploadLookups}
                                        >
                                            {uploadingLookups ? "Uploading..." : "Upload"}
                                        </button>
                                    </div>

                                    <div className="fatf-desc">
                                        Accepts FATF CSV: <b>`Country,Geographic Risk Score,FATF Category` or `type,country,score`</b>
                                    </div>

                                    {lookupMeta?.fileName && (
                                        <div className="fatf-desc">
                                            Latest uploaded file: <strong>{lookupMeta.fileName}</strong> {lookupMeta.uploadedAt ? ` (${new Date(lookupMeta.uploadedAt).toLocaleString()})` : ''}
                                            {lookupMeta.uploadedBy ? ` by ${lookupMeta.uploadedBy}` : ''}
                                        </div>
                                    )}

                                    {lookupMeta?.storage?.storage_mode && (
                                        <div className="fatf-storage">
                                            Storage: <b>{lookupMeta.storage.storage_mode}</b>
                                        </div>
                                    )}

                                    {lookupUploadMsg && <div className="muted" style={{ marginTop: 6 }}>{lookupUploadMsg}</div>}





                                </div>
                            </div>
                        </div>


                        <div>
                            <div className="case-header">
                                <div className="case-left">
                                    <span className="upload-history-label">Upload History</span>
                                </div>


                            </div>

                            <div className=" all_inv_newinv_table">
                                <Table
                                    striped

                                    className="bg-white ps-4 pe-4 text-center "
                                >
                                    <thead className=" Cpointer ">
                                        <tr>
                                            <th className={`text-black  ${"text-start"}`}>File</th>
                                            <th className={`text-black  ${"text-start"}`}>Uploaded At</th>
                                            <th className={`text-black  ${"text-start"}`}>Uploaded By</th>
                                            <th className={`text-black  ${"text-start"}`}>Status</th>
                                            <th className={`text-black  ${"text-start"}`}>Action</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {uploadHistory.map((it) => (
                                            <tr key={it.uploadId}>
                                                <td>{it.fileName || '-'}</td>
                                                <td>{it.uploadedAt ? moment(it.uploadedAt).format("DD-MMM-YYYY hh:mm A") : ""}</td>

                                                <td>{it.uploadedBy || '-'}</td>
                                                <td>
                                                    <span
                                                        className={
                                                            it.isActive === true
                                                                ? "tag tag-success"
                                                                : it.isActive === false
                                                                    ? "tag tag-danger"
                                                                    : ""
                                                        }
                                                    >
                                                        {it.isActive === true
                                                            ? "Active"
                                                            : it.isActive === false
                                                                ? "Archived"
                                                                : "-"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {/* View Button */}
                                                        <button
                                                            type="button"
                                                            className="icon-btn"
                                                            title="View CSV file"
                                                            onClick={() => {
                                                                const url = `${process.env.REACT_APP_API_BASE_URL}/risk/lookups/history/${it.uploadId}/preview`;
                                                                window.open(url, "_blank");
                                                            }}
                                                        >
                                                            <EyeIcon />
                                                        </button>

                                                        {/* Download Button */}
                                                        <a
                                                            className="btn btn-secondary btn-sm"
                                                            href={`${process.env.REACT_APP_API_BASE_URL}/risk/lookups/history/${it.uploadId}/download`}
                                                            download
                                                        >
                                                            Download
                                                        </a>
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}


                                    </tbody>





                                </Table>
                            </div>

                        </div>
                    </div>

                </div>

            </div>








        </div >
    )
}

export default EKYCList;


export const Filters = ({ label, className, disabled, htmlFor, name, data, onChange, id, defaultvalue, selectedValue }) => {
    //   const options =
    //     data.map(item => ({ value: name, label: item }));
    //   const value = selectedValue ? {
    //     value: name,
    //     label: selectedValue
    //   } : null;

    return (
        <div className={className}>
            <label htmlFor={htmlFor} className="form-label">
                <p>{label}</p>
            </label>
            <Select
                isDisabled={disabled}
                id={id}
                name={name}
                // onChange={onChange}
                // options={options}
                // value={value}
                classNamePrefix="custom-select"
            />
        </div>
    );
};

